import { HttpClient, provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { ApplicationConfig, inject, provideAppInitializer } from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideUserIdleConfig } from 'angular-user-idle';
import { ROUTES } from './app.routes';
import { HTTP_INTERCEPTOR } from './shared/interceptors/http.interceptor';
import { loadingInterceptor } from './shared/interceptors/loading-interceptor';
import { BannerConfigService } from './shared/services/banner-config-service';
import { AnnouncementBannerConfig } from './shared/interfaces/announcemnt-banner-config';
import { firstValueFrom } from 'rxjs';

export const APP_CONFIG: ApplicationConfig = {
  providers: [
    //provideRouter(ROUTES, withHashLocation(), withDebugTracing()),
    provideRouter(ROUTES, withHashLocation()),
    provideAnimationsAsync(),
    provideHttpClient(withXhr(), withInterceptors([HTTP_INTERCEPTOR])),
    provideAppInitializer(() => {
      const http = inject(HttpClient);;
      const bannerService = inject(BannerConfigService);

      return firstValueFrom(
        http.get<AnnouncementBannerConfig[]>('assets/config/banner-config.json'))
        .then(config => {
          bannerService.setConfig(config);
        }).catch(error => {
          console.error('could not load announcement banner config', error);
          bannerService.setConfig([]);
        });
    }),
    //the total timeout time is idle + idleSensitivity + timeout.
    provideUserIdleConfig({
      idle: 1740, //29 minutes of idle time before user countdown starts
      timeout: 60 //1 minute countdown for user to click the modal and keep active session
    }),
    provideNativeDateAdapter(),
  ]
};
